import type { AdminRole } from '../types/config';
import type { AdminPage } from '../types/navigation';

export type AdminAction = 'verify' | 'office_docs' | 'reconcile' | 'office_payment' | 'note' | 'approve' | 'sign' | 'assign' | 'config' | 'export' | 'cancel_letter';

const ALL_ACTIONS: AdminAction[] = ['verify', 'office_docs', 'reconcile', 'office_payment', 'note', 'approve', 'sign', 'assign', 'config', 'export', 'cancel_letter'];

const ROLE_ACTIONS: Record<AdminRole, AdminAction[]> = {
  admin: ALL_ACTIONS,
  divisional: ['verify', 'office_docs', 'note', 'assign', 'export'],
  verifier: ['verify', 'office_docs'],
  accounts: ['reconcile', 'office_payment', 'export'],
  dealing: ['note'],
  approver: ['approve'],
  signatory: ['sign', 'cancel_letter'],
  station: ['export'],
  hq: ['export'],
};

const ALL_PAGES: AdminPage[] = ['dashboard', 'cases', 'inventory', 'stations', 'verification', 'payments', 'notesheet', 'letters', 'handover', 'reports', 'users', 'config', 'audit'];

const ROLE_PAGES: Record<AdminRole, AdminPage[]> = {
  admin: ALL_PAGES,
  divisional: ['dashboard', 'cases', 'inventory', 'stations', 'verification', 'payments', 'notesheet', 'letters', 'handover', 'reports'],
  verifier: ['dashboard', 'cases', 'inventory', 'verification', 'payments'],
  accounts: ['dashboard', 'cases', 'payments', 'reports'],
  dealing: ['dashboard', 'cases', 'notesheet', 'letters'],
  approver: ['dashboard', 'cases', 'notesheet', 'reports'],
  signatory: ['dashboard', 'cases', 'notesheet', 'letters'],
  station: ['dashboard', 'cases', 'inventory', 'stations', 'handover'],
  hq: ['dashboard', 'cases', 'inventory', 'stations', 'handover', 'reports', 'audit'],
};

export const can = (role: AdminRole, action: AdminAction) => ROLE_ACTIONS[role].includes(action);
export const pagesFor = (role: AdminRole) => ROLE_PAGES[role];
export const DENIED = 'এই কার্যক্রম আপনার ভূমিকায় অনুমোদিত নয়';
